import React from 'react';
import { Card } from 'react-bootstrap';
import NotificationsDashboard from './Notifications';
const Notifications = () => {
    return (
        <div className="container-fluid px-3 px-lg-4">
            <div className="pagetitle d-flex justify-content-between align-items-center">
                <h1>
                    <i className="bi bi-bell"></i> Notifications
                </h1>
            </div>

            <Card className="notifications-card shadow-sm border-0">
                <Card.Body className="p-3">
                    <NotificationsDashboard />
                </Card.Body>
            </Card>
        </div>
    );
};

export default Notifications;
